import React from 'react';
import { CprDecisionType } from '../../../utils';

interface HasCprDecisionProps {
  cprDecision: CprDecisionType;
  setCprDecision: React.Dispatch<React.SetStateAction<CprDecisionType>>;
}

const cprDecisionOptions = [
  {
    value: 'for_cpr',
    label: 'Yes, For attempted cardiopulmonary resuscitation',
    snomedCode: '450475007',
  },
  {
    value: 'not_for_cpr',
    label: 'No, Not for attempted cardiopulmonary resuscitation',
    snomedCode: '450476008',
  },
  {
    value: 'not_yet_made',
    label: 'Decision not yet made',
    snomedCode: null,
  },
  {
    value: 'discussion_not_appropriate',
    label: 'Discussion not appropriate at this time',
    snomedCode: '931761000000106',
  },
];
const CprDecision: React.FC<HasCprDecisionProps> = ({
  cprDecision,
  setCprDecision,
}) => {
  return (
    <div className="mt-2 govuk-bp:mt-5">
      <div className="govuk-form-group">
        <fieldset className="govuk-fieldset">
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              What is the documented CPR Decision?
            </h1>
          </legend>
          <div className="govuk-body">
            The cardio-pulmonary resuscitation (CPR) decision.
          </div>
          <div className="govuk-radios" data-module="govuk-radios">
            {cprDecisionOptions.map(option => (
              <div className="govuk-radios__item" key={option.value}>
                <input
                  className="govuk-radios__input"
                  id="cpr-decision"
                  name="hasCprDecision"
                  type="radio"
                  value={option.value}
                  checked={cprDecision.status === option.value}
                  onChange={() => {
                    setCprDecision(prev => ({
                      ...prev,
                      status: option.value,
                      snomedCode: option.snomedCode,
                    }));
                  }}
                />
                <label
                  className="govuk-label govuk-radios__label"
                  htmlFor={option.value}
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default CprDecision;
